// css
import 'assets/style/elements/input.scss'

// elements
import IconButton from 'components/elements/IconButton'
import Text from 'components/elements/Text'
import { useEffect } from 'react'

/**
 * @icon {String}  - search, write
 */
function Element({
  type = 'text',
  value = '',
  className = '',
  placeholder = '입력하세요.',
  disabled = false,
  readOnly = false,
  register = null,
  icon = null,
  iconOnClick = () => {},
  onClick = () => {},
  onChange = () => {},
  onKeyUp = () => {},
  onKeyDown = () => {},
  onBlur = () => {},
  onFocus = () => {},
  error = false,
  errorMessage = null,
  rows = 10,
  style = {},
  inputStyle = {},
  maxLength,
  inputMode = '',
  pattern = '',
  setDeleteFlag,
}) {
  let classNameWrap = ' ' + className
  if (icon !== null) classNameWrap += ' in-icon icon-' + icon

  if ([true, 'true'].includes(error)) className += ' error'

  const handleDeleteValue = () => {
    onChange?.('')
  }

  const eraseStyle = icon === 'erase' ? { width: '100%', paddingRight: '36px', boxSizing: 'border-box' } : {}

  return (
    <div className={'input-text-wrap' + classNameWrap} style={style}>
      {(() => {
        if (type === 'textarea') {
          return (
            <textarea
              className={'input-text ' + className}
              value={register ? undefined : value}
              placeholder={placeholder}
              onChange={onChange}
              rows={rows}
              style={{ lineHeight: '25px' }}
              {...register}
            />
          )
        } else {
          return (
            <>
              <input
                type={type}
                className={'input-text'}
                value={register ? undefined : value}
                placeholder={placeholder}
                disabled={disabled}
                readOnly={readOnly}
                onChange={(e) => {
                  if (pattern) {
                    let value = e.target.value

                    // 숫자, 점(.), 마이너스(-)만 허용
                    value = value.replace(/[^0-9.-]/g, '')

                    // 첫 글자 이외의 마이너스 제거
                    value = value.replace(/(?!^)-/g, '')

                    // 점(.)은 하나만
                    value = value.replace(/(\..*?)\..*/g, '$1')

                    // 소수점 이하 한 자리까지만
                    value = value.replace(/(\.\d{1})\d+/g, '$1')

                    // 정수 부분 3자리 제한
                    value = value.replace(/^(-?\d{3})\d+/, '$1')

                    e.target.value = value
                  }
                  onChange?.(e)
                }}
                onClick={onClick}
                onKeyUp={onKeyUp}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                onFocus={onFocus}
                style={{ ...inputStyle, ...eraseStyle }}
                inputMode={{ ...inputMode }}
                {...(maxLength ? { maxLength } : {})}
                {...register}
              />
            </>
          )
        }
      })()}
      {errorMessage !== null && <Text className="f-12 c-error mt4" text={errorMessage} />}
      {icon !== null && icon !== 'erase' && <IconButton type={icon} size="24" onClick={iconOnClick} />}
      {icon !== null && icon === 'erase' && (
        <div
          className="input-adornment-root input-adronment-end"
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {value ? (
            <button
              type="button"
              className="input-adornment btn-del-circle"
              onClick={() => {
                handleDeleteValue()
                setDeleteFlag?.(true)
              }}
              style={{
                width: '20px',
                height: '20px',
                border: 'none',
                marginLeft: '8px',
                marginRight: '4px',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: '-8px',
                  left: '-16px',
                  right: '-8px',
                  bottom: '-8px',
                  content: '""',
                }}
              />
              <span className="sr-only">삭제</span>
            </button>
          ) : null}
        </div>
      )}
    </div>
  )
}

export default Element
